<template>
  <main role="Ekspedisi">
    <div class="row">
      <!-- <div class="col-md-12"> -->
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Ekspedisi</h4>
        </div>
        <div class="card-body">
          <ul class="list-group">
            <li
              class="
                list-group-item
                d-flex
                justify-content-between
                align-items-center
                active
              "
            >
              Pilihan Ekspedisi
            </li>

            <content-placeholders>
              <li
                v-for="loop in fakeLooping"
                :key="loop"
                class="
                  list-group-item
                  d-flex
                  justify-content-between
                  align-items-center
                  forPlacholder
                "
              >
                <div class="text-left">
                  <content-placeholders-heading :img="true" />
                  <content-placeholders-text :lines="2" />
                </div>
                <content-placeholders-text :lines="1" />
              </li>
            </content-placeholders>

            <li
              v-for="(ekspedisi, index) in ekspedisis"
              :key="index"
              class="
                list-group-item
                d-flex
                justify-content-between
                align-items-center
              "
            >
              <div class="text-left">
                <img
                  :src="ekspedisi.image"
                  class="img-fluid img-container"
                  alt=""
                />
                {{ ekspedisi.name }}
              </div>

              <input
                class="change_status"
                :checked="ekspedisi.isChecked"
                type="checkbox"
                status="1"
                :data_id="ekspedisi.id"
                :data_name="ekspedisi.name"
                data-toggle="toggle"
                data-on="Melayani"
                data-off="Tidak"
                data-onstyle="warning"
                data-style="ios"
              />
            </li>
          </ul>
        </div>
      </div>
      <!-- </div> -->
    </div>
  </main>
</template>

<script>
// import Success from "../ToastComponent/EkspedisiSuccess";
import $ from "jquery";
import axios from "axios";

export default {
  components: {},
  data() {
    return {
      ekspedisis: {},
      itemsNotAdd: {},
      fakeLooping: 3,
      // isAvaibility: "Avaibility",
    };
  },

  created() {
    this.getAndPostEkspedisi();
  },
  methods: {
    getAndPostEkspedisi() {
      const globalThis = this;
      let ekpedisiUrl = "seller/setting/expedition";
      axios
        .get(ekpedisiUrl)
        // .then(sleeper(1000))
        .then((response) => {
          // console.log(response);
          return response.data;
        })
        .then((data) => {
          // console.log(data.data.items);
          this.ekspedisis = data.data.items;
          this.itemsNotAdd = data.data.itemsNotAdd;
        })
        .then(() => {
          $(".vue-content-placeholders-text").remove();
          $(".vue-content-placeholders-heading").remove();
          $(".change_status").bootstrapToggle();
          $(".forPlacholder").remove();
        })
        .then(() => {
          $(".toggle-off").css("height", "100%");
          $(".change_status").on("change", function() {
            let idEks = $(this).attr("data_id");
            let nameEks = $(this).attr("data_name");
            // console.log(idEks)
            axios
              .put("seller/setting/expedition", { id: idEks })
              .then((res) => {
                let result = res.data.data;
                result === 1
                  ? globalThis.$toast.success(
                      `Status pengiriman ${nameEks} diubah menjadi 'Melayani'`
                    )
                  : globalThis.$toast.error(
                      `Status pengiriman ${nameEks} diubah menjadi 'Tidak Melayani'`
                    );
              })
              .catch((error) => {
                // error.response.status Check status code
                console.log(error);
              });
          });
        });
    },
  },
};
</script>

<style scoped>
/* .toggle.ios .toggle-handle {
  border-radius: 20rem !important;
  background-color: rgb(37, 37, 37) !important;
  margin: 0px 0px 0px 0px !important;
} */
</style>
